import { Box } from '@customerio/pluma-components/react';

/** Password step. Placeholder — content lands with FPS-2859. */
export function PasswordStep() {
  return <Box data-testid="signup-step-password" />;
}
